import { FC } from 'react';

import { IconProps } from './types';

export const DevicesIcon: FC<IconProps> = ({
	color = '#06519E',
	height = 24,
	size,
	width = 24,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M20 10c1.654 0 3 1.35 3 3v6c0 1.65-1.346 3-3 3h-2c-1.654 0-3-1.35-3-3v-6c0-1.65 1.346-3 3-3Zm0 2h-2c-.552 0-1 .45-1 1v6c0 .55.448 1 1 1h2c.552 0 1-.45 1-1v-6c0-.55-.448-1-1-1M16 2c1.654 0 3 1.35 3 3v2a1.001 1.001 0 0 1-2 0V5c0-.55-.448-1-1-1H4c-.551 0-1 .45-1 1v7c0 .55.449 1 1 1h8c.552 0 1 .45 1 1s-.448 1-1 1h-1v2h1c.552 0 1 .45 1 1s-.448 1-1 1H7c-.552 0-1-.45-1-1s.448-1 1-1h2v-2H4c-1.654 0-3-1.35-3-3V5c0-1.65 1.346-3 3-3Z"
		/>
	</svg>
);
